import React from 'react';
import { getOffsetWidth } from 'utils';

export default Component => props => (
    <Component {...props} offsetWidth={getOffsetWidth() || 0} />
);
